(function () {
  var scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

  function initializeBuyButton(container) {
    var domain = container.dataset.partnerDomain;
    var token = container.dataset.partnerToken;
    var productId = container.dataset.partnerProductId;

    if (!domain || !token || !productId) {
      return;
    }

    function ShopifyBuyInit() {
      var client = ShopifyBuy.buildClient({
        domain: domain,
        storefrontAccessToken: token
      });

      ShopifyBuy.UI.onReady(client).then(function (ui) {
        ui.createComponent('product', {
          id: productId,
          node: container,
          moneyFormat: '%24%7B%7Bamount%7D%7D',
          options: {
            product: {
              styles: {
                button: {
                  color: '#000000',
                  backgroundColor: '#ffffff',
                  borderRadius: '0px'
                }
              },
              buttonDestination: 'checkout',
              text: {
                button: 'Buy now'
              }
            }
          }
        });
      });
    }

    if (window.ShopifyBuy) {
      if (window.ShopifyBuy.UI) {
        ShopifyBuyInit();
      } else {
        loadScript(ShopifyBuyInit);
      }
    } else {
      loadScript(ShopifyBuyInit);
    }
  }

  function loadScript(callback) {
    var script = document.createElement('script');
    script.async = true;
    script.src = scriptURL;
    script.onload = callback;
    document.head.appendChild(script);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var containers = document.querySelectorAll('[data-partner-buy-button]');

    containers.forEach(function (container) {
      initializeBuyButton(container);
    });
  });
})();